export const FAQ_CONSTANTS = {
  DEFAULT_PREVIEW_COUNT: 3,
  NO_FAQS_MESSAGE: "No FAQs available",
  DEFAULT_TITLE: "FAQ's",
} as const;
